import {
  AfterContentInit,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  ChangeDetectionStrategy,
} from '@angular/core';
import { SpinnerService } from '../services/spinner/spinner.service';
import { Subscription } from 'rxjs';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-progress-spinner',
  templateUrl: 'progress-spinner.component.html',
  styleUrls: ['progress-spinner.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [CommonModule],
})
export class ProgressSpinnerComponent implements OnDestroy, AfterContentInit {
  public showSpinner = false;
  private unsubscribe: Subscription[] = [];
  constructor(
    private spinnerService: SpinnerService,
    private cdRef: ChangeDetectorRef,
  ) {}

  ngOnDestroy() {
    this.unsubscribe.forEach((s) => s.unsubscribe());
  }

  ngAfterContentInit() {
    this.unsubscribe.push(
      this.spinnerService.visibility.subscribe((spin) => {
        // Defer the state mutation to a microtask so it can't interleave
        // with an ongoing CD cycle from whatever component called show()/hide().
        // Using markForCheck() instead of detectChanges() prevents recursive
        // CD, which was triggering NG0100 on sibling components (e.g.
        // ResidentDetailComponent's @if blocks).
        queueMicrotask(() => {
          this.showSpinner = spin;
          this.cdRef.markForCheck();
        });
      }),
    );
  }
}
